import { render, staticRenderFns } from "./MenusPanel.vue?vue&type=template&id=1b6ad758&"
import script from "./MenusPanel.vue?vue&type=script&lang=js&"
export * from "./MenusPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports